import { PredefinedTokenKey, TokenKey, Tokens } from './types';
import { FC } from 'react';
import { EmptyState, EmptyStateIcons } from '@silverfort/sf-components';
import TokenActions from './components/TokenActions';
import { TokenRow } from './components/TokenTable';

import { tokenComponentsMap } from './tokenComponentsMap';

interface ProviderProps {
    selectedMfaToken?: PredefinedTokenKey;
    visibleFields: Tokens;
    dispatch: React.Dispatch<any>;
    save: () => void;
    onCancel: () => void;
    editToken?: TokenKey;
    editTenantId?: string;
    editEntraIdToken?: string;
    configuredTokens: TokenRow[];
}

const MFATokenProvider: FC<ProviderProps> = ({
    selectedMfaToken,
    visibleFields,
    dispatch,
    save,
    onCancel,
    editToken,
    editTenantId,
    editEntraIdToken,
    configuredTokens
}) => {
    if (!selectedMfaToken)
        return (
            <div className="flex flex-1 flex-col">
                <div className="flex flex-1 items-center border border-sf-gray-100 rounded-lg mb-2">
                    <EmptyState
                        title={configuredTokens.length === 0 ? 'No Tokens available' : 'Configure MFA Token'}
                        description="Select an MFA provider to begin adding tokens"
                        icon={EmptyStateIcons.NoItems}
                        className="w-full h-full"
                    />
                </div>
                <div className="justify-end flex flex-1">
                    {configuredTokens.length > 0 && (
                        <TokenActions onCancel={onCancel} onSave={save} saveDisabled={true} />
                    )}
                </div>
            </div>
        );

    const tokenConfig = tokenComponentsMap[selectedMfaToken];
    if (!tokenConfig) return null;

    const { component: ProviderComponent, id } = tokenConfig;

    return (
        <ProviderComponent
            fields={visibleFields[id]?.fields || []}
            dispatch={dispatch}
            onSave={save}
            onCancel={onCancel}
            editToken={editToken}
            editTenantId={editTenantId}
            editEntraIdToken={editEntraIdToken}
        />
    );
};

export default MFATokenProvider;
